// frontend/src/services/deviceServices.js
import { commandFactory } from './core/CommandFactory.js';

/**
 * Serwis wysokiego poziomu do zarządzania urządzeniami
 * Używa CommandFactory do wykonywania operacji
 */
export class DeviceService {
  constructor() {
    this.apiClient = commandFactory.getApiClient();
  }

  // === DEVICE MANAGEMENT ===
  
  /**
   * Pobierz wszystkie urządzenia użytkownika
   */
  async getDevices() {
    return this.apiClient.get('/devices/get-user-devices/');
  }

  /**
   * Pobierz tylko huby użytkownika
   */
  async getHubs() {
    return this.apiClient.get('/devices/get-user-hubs/');
  }

  /**
   * Pobierz urządzenia oczekujące na zatwierdzenie
   */
  async getPendingDevices() {
    return this.apiClient.get('/devices/get-pending-devices/');
  }

  /**
   * Zatwierdź urządzenie
   */
  async approveDevice(deviceUuid) {
    return this.apiClient.post(`/devices/approve-device/${deviceUuid}/`);
  }

  /**
   * Odrzuć urządzenie
   */
  async rejectDevice(deviceUuid) {
    return this.apiClient.post(`/devices/reject-device/${deviceUuid}/`);
  }

  // === AUTH CODES ===
  
  /**
   * Wygeneruj nowy kod autoryzacyjny
   */
  async generateAuthCode() {
    return this.apiClient.post('/devices/generate-auth-code/');
  }

  /**
   * Pobierz aktywny kod autoryzacyjny
   */
  async getAuthCode() {
    return this.apiClient.get('/devices/get-auth-code/');
  }

  // === DEVICE COMMANDS ===
  
  /**
   * Wykonaj komendę na urządzeniu (automatycznie wybiera odpowiedni serwis)
   */
  async executeCommand(deviceUuid, deviceType, command, data = {}, options = {}) {
    const commandService = commandFactory.getCommandService(deviceType);
    return commandService.executeCommand(deviceUuid, command, data, options);
  }

  /**
   * Pobierz serwis komend dla konkretnego typu urządzenia
   */
  getCommandService(deviceType) {
    return commandFactory.getCommandService(deviceType);
  }

  // === PRINTER PAIRING ===

  /**
   * Paruj drukarkę BambuLab z hubem NestHub
   */
  async pairBambulabPrinter(hubUuid, printerData) {
    const endpoint = `/devices/nesthub/${hubUuid}/pair-bambulab-printer/`;
    return this.apiClient.post(endpoint, printerData);
  }
}

// Export singleton instance
export const deviceService = new DeviceService();

// Export legacy apiService for backward compatibility
export const apiService = {
  // Device management
  getDevices: () => deviceService.getDevices(),
  getHubs: () => deviceService.getHubs(),
  getPendingDevices: () => deviceService.getPendingDevices(),
  approveDevice: (deviceUuid) => deviceService.approveDevice(deviceUuid),
  rejectDevice: (deviceUuid) => deviceService.rejectDevice(deviceUuid),
  
  // Auth codes
  generateAuthCode: () => deviceService.generateAuthCode(),
  getAuthCode: () => deviceService.getAuthCode(),
  
  // Legacy command methods - deprecated, use deviceService.executeCommand instead
  getHubPrintersAsync: (hubUuid) => {
    const nestHubService = commandFactory.getCommandService('NestHub');
    return nestHubService.getPrinters(hubUuid, { async: true });
  },
  
  checkTaskStatus: (taskId) => {
    const genericService = commandFactory.getCommandService('generic');
    return genericService.checkTaskStatus(taskId);
  },
  
  executeHubCommand: (hubUuid, command, data = {}, timeout = 30) => {
    const nestHubService = commandFactory.getCommandService('NestHub');
    return nestHubService.executeCommand(hubUuid, command, data, { timeout });
  },
  
  // Printer pairing
  pairBambulabPrinter: (hubUuid, printerData) => {
    return deviceService.pairBambulabPrinter(hubUuid, printerData);
  }
};
